import { currencyNumber } from '@sales-center/common'
import { IPropertyFilter } from './IPropertyFilter'

export type ValueRange = {
  min: string
  max: string
}

export const isValidValueRange = ({ min, max }: ValueRange): boolean =>
  min !== '' || max !== ''

export interface IValueRangeFilter<T> extends IPropertyFilter<T> {
  type: 'valueRange'
  value: ValueRange
}

export const isValueRangeFilter = <T>(
  filter: IPropertyFilter<T>,
): filter is IValueRangeFilter<T> => filter.type === 'valueRange'

export const normalizeValueRangeFilter = <T>({
  propertyName,
  value: { min, max },
}: IValueRangeFilter<T>) => {
  if (min === '' && max === '') return ''

  const minValue = currencyNumber(min)
  const maxValue = currencyNumber(max)

  const propertyNameStr = String(propertyName)

  let range = ''

  if (minValue === maxValue) {
    // single value
    range = `(${propertyNameStr} eq ${minValue})`
  } else if (min === '') {
    // only max set
    range = `(${propertyNameStr} le ${maxValue} or ${propertyNameStr} eq null)`
  } else if (max === '') {
    // only min set
    if (minValue === 0)
      range = `(${propertyNameStr} ge ${minValue} or ${propertyNameStr} eq null)`
    else range = `(${propertyNameStr} ge ${minValue})`
  } else {
    // min and max
    range = `(${propertyNameStr} ge ${minValue} and ${propertyNameStr} le ${maxValue})`
    if (minValue === 0 || maxValue === 0) {
      // include null if min or max = 0
      range = `(${range} or ${propertyNameStr} eq null)`
    }
  }

  return range
}
